import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createBlock(_component_Swiper, {
    slidesPerView: 1,
    spaceBetween: 24,
    centeredSlides: false,
    preventClicks: true,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      0: { slidesPerView: 3, spaceBetween: 12 },
      420: { slidesPerView: 4, spaceBetween: 16 },
      576: { slidesPerView: 4 },
      768: { slidesPerView: 4 },
      992: { slidesPerView: 5 },
      1200: { slidesPerView: 6 },
      1440: { slidesPerView: 6 },
    },
    modules: _ctx.modules,
    class: "partner-slide d-md-none"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.effectiveSlides, (slide, i) => {
        return (_openBlock(), _createBlock(_component_SwiperSlide, { key: i }, {
          default: _withCtx(() => [
            _createVNode(_component_RouterLink, { to: "/" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: slide.image,
                  alt: "partner"
                }, null, 8, _hoisted_1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["modules"]))
}